import { Record, List } from 'immutable';

const defaultValues = {
  id: null,
  designId: null,
  title: '',
  frontCallout: '',
  backCallout: '',
  backMessage: '',
  backFinePrint: '',
  designPageId: 0,
};

export default class BuzzCard extends Record(defaultValues, BuzzCard) {
  constructor(values) {
    super({
      ...values,
    });
  }
}

export const BuzzCards = (data) => {
  let buzzcard = new List();
  if (data) {
    data.forEach((value) => {
      buzzcard = buzzcard.push(new BuzzCard(value));
    });
  }
  return buzzcard;
};
